// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2ugEW","col":"Table_col__Mz1-I","fulfillmentStatus":"Table_fulfillmentStatus__3S66T","emailCol":"Table_emailCol__2nywy"};